<template>
  <div class="main">
    <GoBack :name="`个人资料`" :type="2" :path="`/mobile/my`"></GoBack>

    <!-- //阴影 -->
    <img class="shadow" src="@/assets/mobile/image/common/shadow.png" />

    <div class="content-personal">
      <!-- 完善个人资料可获得 -->
      <div class="gantan-box">
        <img class="gantan" src="@/assets/mobile/image/my/gantan.png" />
        <div>完善个人资料可获得<span>10信用值</span></div>
      </div>
      <!-- 头像部分 -->
      <div class="head-card card-box">
        <div class="top">
          <div class="left">头像</div>
          <div class="head-box">
            <img
              class="head"
              v-if="$store.state.userInfo.avatarUrl"
              :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
            />
            <img class="head" v-else src="@/assets/image/module/head.png" />

            <div class="picture-box" @click="dialogVisible = true">
              <i class="el-icon-camera"></i>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="left">注册账号</div>
          <div class="right">{{ $store.state.userInfo.userName }}</div>
        </div>
      </div>
      <!-- 个人信息 -->
      <div class="user-info card-box">
        <div class="input-box">
          <div class="name">姓名</div>
          <input
            v-model="profileInfo.name"
            :disabled="isName"
            placeholder="请输入姓名"
          />
        </div>
        <div class="input-box">
          <div class="name">性别</div>
          <div class="choice-box" @click="show = true">
            <span v-if="!this.profileInfo.gender">请选择</span>

            <span v-else>
              {{ this.profileInfo.gender | leablDateFrom(option1) }}</span
            >

            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
        </div>
        <div class="input-box">
          <div class="name">出生日期</div>
          <div class="choice-box" @click="birthdayPicker = true">
            <span v-if="!profileInfo.birthday"> 请选择</span>
            <span v-else>{{ profileInfo.birthday }}</span>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
        </div>
        <div class="input-box">
          <div class="name">省份</div>
          <div class="choice-box" @click="provincePicker = true">
            <span v-if="!this.profileInfo.provinceId">请选择</span>
            <span v-else>
              {{ profileInfo.provinceId | nameFrom(province) }}</span
            >
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
        </div>

        <div class="input-box">
          <div class="name">城市</div>
          <div class="choice-box" @click="citiesPicker = true">
            <span v-if="!this.profileInfo.cityId">请选择</span>
            <span v-else> {{ profileInfo.cityId | nameFrom(cities) }}</span>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
        </div>

        <div class="input-box">
          <div class="name">区/县</div>
          <div class="choice-box" @click="districtsPicker = true">
            <span v-if="!this.profileInfo.districtId">请选择</span>
            <span v-else>
              {{ profileInfo.districtId | nameFrom(districts) }}</span
            >
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
        </div>

        <div class="input-box">
          <div class="name">婚姻状况</div>
          <div class="choice-box" @click="maritalStatusPicker = true">
            <span v-if="!this.profileInfo.maritalStatus">请选择</span>
            <span v-else>
              {{
                profileInfo.maritalStatus
                  | labelName(MaritalStatus, "MarriageName")
              }}</span
            >
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="maritalStatusPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="MaritalStatus"
              @cancel="maritalStatusPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.maritalStatus = e.ID;
                  this.maritalStatusPicker = false;
                }
              "
              value-key="MarriageName"
              :default-index="MaritalIndex"
            />
          </van-popup>
        </div>

        <div class="input-box">
          <div class="name">学历</div>
          <div class="choice-box" @click="educationsPicker = true">
            <span v-if="!this.profileInfo.educationId">请选择</span>
            <span v-else>
              {{
                profileInfo.educationId | labelName(Educations, "EducationName")
              }}
            </span>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="educationsPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="Educations"
              @cancel="educationsPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.educationId = e.ID;
                  this.educationsPicker = false;
                }
              "
              value-key="EducationName"
              :default-index="EducationIndex"
            />
          </van-popup>
        </div>

        <div class="input-box">
          <div class="name">工作状态</div>
          <div class="choice-box" @click="OccupationStatusPicker = true">
            <div class="title" v-if="!profileInfo.occupationStatus">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{
                profileInfo.occupationStatus
                  | labelName(OccupationStatus, "WSName")
              }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="OccupationStatusPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="OccupationStatus"
              @cancel="OccupationStatusPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.occupationStatus = e.ID;
                  this.OccupationStatusPicker = false;
                }
              "
              value-key="WSName"
              :default-index="occupationStatusIndex"
            />
          </van-popup>
        </div>

        <div class="input-box">
          <div class="name">个人月收入</div>
          <div class="choice-box" @click="personalIncomePicker = true">
            <div class="title" v-if="!profileInfo.personalIncome">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{
                profileInfo.personalIncome | labelName(Incomes, "IncomeName")
              }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="personalIncomePicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="Incomes"
              @cancel="personalIncomePicker = false"
              @confirm="
                (e) => {
                  personalConfirm(e);
                }
              "
              value-key="IncomeName"
              :default-index="personalIncomeIndex"
            />
          </van-popup>
        </div>

        <div class="input-box">
          <div class="name">家庭月收入</div>
          <div class="choice-box" @click="familyIncomePicker = true">
            <div class="title" v-if="!profileInfo.familyIncome">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{ profileInfo.familyIncome | labelName(Incomes, "IncomeName") }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="familyIncomePicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="Incomes2"
              @cancel="familyIncomePicker = false"
              @confirm="
                (e) => {
                  familyConfirm(e);
                }
              "
              value-key="IncomeName"
              :default-index="familyIncomeIndex"
            />
          </van-popup>
        </div>

        <div class="input-box">
          <div class="name">职位</div>
          <div class="choice-box" @click="positionIdPicker = true">
            <div class="title" v-if="!profileInfo.positionId">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{
                profileInfo.positionId | labelName(Positions, "PositionName")
              }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="positionIdPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="Positions"
              @cancel="positionIdPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.positionId = e.ID;
                  this.positionIdPicker = false;
                }
              "
              value-key="PositionName"
              :default-index="provinceIdIndex"
            />
          </van-popup>
        </div>

        <div class="input-box">
          <div class="name">是否有小孩</div>
          <div class="choice-box" @click="hasChildrenPicker = true">
            <div
              class="title"
              v-if="
                !profileInfo.hasChildren && profileInfo.hasChildren !== false
              "
            >
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{ profileInfo.hasChildren ? "是" : "否" }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="hasChildrenPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="options"
              @cancel="hasChildrenPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.hasChildren = e.ID;
                  this.hasChildrenPicker = false;
                }
              "
              value-key="label"
              :default-index="hasChildrenIndex"
            />
          </van-popup>
        </div>

        <div class="input-box" v-if="profileInfo.hasChildren">
          <div class="name">最小小孩的性别</div>
          <div class="choice-box" @click="childGenderPicker = true">
            <div class="title" v-if="!profileInfo.childGender">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{ profileInfo.childGender === 1 ? "男" : "女" }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="childGenderPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="options1"
              @cancel="childGenderPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.childGender = e.ID;
                  this.childGenderPicker = false;
                }
              "
              value-key="label"
              :default-index="childGenderIndex"
            />
          </van-popup>
        </div>

        <div class="input-box" v-if="profileInfo.hasChildren">
          <div class="name">最小小孩出生年份</div>
          <div class="choice-box" @click="birthYearOfYoungChildPicker = true">
            <div class="title" v-if="!profileInfo.birthYearOfYoungChild">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{ profileInfo.birthYearOfYoungChild }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup
            v-model="birthYearOfYoungChildPicker"
            round
            position="bottom"
          >
            <van-picker
              show-toolbar
              :columns="YearList"
              @cancel="birthYearOfYoungChildPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.birthYearOfYoungChild = e.year;
                  this.birthYearOfYoungChildPicker = false;
                }
              "
              value-key="year"
              :default-index="birthYearOfYoungChildIndex"
            />
          </van-popup>
        </div>

        <div class="input-box">
          <div class="name">汽车品牌</div>
          <div class="choice-box" @click="vehicleBrandPicker = true">
            <div class="title" v-if="!profileInfo.vehicleBrand">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{
                profileInfo.vehicleBrand | labelName(VehicleBrands, "BrandName")
              }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="vehicleBrandPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="VehicleBrands"
              @cancel="vehicleBrandPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.vehicleBrand = e.ID;
                  this.vehicleBrandPicker = false;
                  this.profileInfo.vehicleModel = null;
                  this.profileInfo.vehiclePurchaseYear = null;
                  this.getVehicleBrandsModels();
                }
              "
              value-key="BrandName"
              :default-index="vehicleBrandIndex"
            />
          </van-popup>
        </div>

        <div
          class="input-box"
          v-if="profileInfo.vehicleBrand && profileInfo.vehicleBrand !== 1"
        >
          <div class="name">汽车型号</div>
          <div class="choice-box" @click="vehicleModelPicker = true">
            <div class="title" v-if="!profileInfo.vehicleModel">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{
                profileInfo.vehicleModel
                  | labelName(VehicleBrandsModels, "ModelName")
              }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup v-model="vehicleModelPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="VehicleBrandsModels"
              @cancel="vehicleModelPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.vehicleModel = e.ID;
                  this.vehicleModelPicker = false;
                }
              "
              value-key="ModelName"
              :default-index="vehicleModelIndex"
            />
          </van-popup>
        </div>

        <div
          class="input-box"
          v-if="profileInfo.vehicleBrand && profileInfo.vehicleBrand !== 1"
        >
          <div class="name">常用汽车购买年份</div>
          <div class="choice-box" @click="vehiclePurchaseYearPicker = true">
            <div class="title" v-if="!profileInfo.vehiclePurchaseYear">
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2">
              {{ profileInfo.vehiclePurchaseYear }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup
            v-model="vehiclePurchaseYearPicker"
            round
            position="bottom"
          >
            <van-picker
              show-toolbar
              :columns="YearList"
              @cancel="vehiclePurchaseYearPicker = false"
              @confirm="
                (e) => {
                  this.profileInfo.vehiclePurchaseYear = e.year;
                  this.vehiclePurchaseYearPicker = false;
                }
              "
              value-key="year"
              :default-index="vehiclePurchaseYearIndex"
            />
          </van-popup>
        </div>

        <div class="input-box" v-if="Diseases1.length !== 0">
          <div class="name">个人患有疾病</div>
          <div class="choice-box" @click="personalDiseasePicker = true">
            <div
              class="title"
              v-if="
                !profileInfo.personalDisease ||
                profileInfo.personalDisease.length === 0
              "
            >
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2 title2te">
              {{ profileInfo.personalDisease | labelName2(Diseases1) }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup
            v-model="personalDiseasePicker"
            round
            position="bottom"
            :style="{ height: '70%' }"
          >
            <div class="stry-top">
              <span @click="personalDiseasePicker = false" class="stry-quxiao"
                >取消</span
              >
              <span @click="personalDiseasePicker = false">确认</span>
            </div>
            <div class="stry-bottom">
              <van-checkbox-group v-model="profileInfo.personalDisease">
                <van-cell v-for="item in Diseases1" :key="item.ID" clickable>
                  <template #title>{{ item.DiseaseName }}</template>
                  <template #right-icon>
                    <van-checkbox
                      :name="item.ID"
                      :disabled="isPersonalDisease(item.ID)"
                    />
                  </template>
                </van-cell>
              </van-checkbox-group>
            </div>
          </van-popup>
        </div>

        <div class="input-box" v-if="Diseases.length !== 0">
          <div class="name">家庭乘员患有疾病</div>
          <div class="choice-box" @click="familyDiseasePicker = true">
            <div
              class="title"
              v-if="
                !profileInfo.familyDisease ||
                profileInfo.familyDisease.length === 0
              "
            >
              {{ $t("module.account.title33") }}
            </div>
            <div v-else class="title2 title2te">
              {{ profileInfo.familyDisease | labelName2(Diseases) }}
            </div>
            <img src="@/assets/mobile/image/my/arrow.png" />
          </div>
          <van-popup
            v-model="familyDiseasePicker"
            round
            position="bottom"
            :style="{ height: '70%' }"
          >
            <div class="stry-top">
              <span @click="familyDiseasePicker = false" class="stry-quxiao"
                >取消</span
              >
              <span @click="familyDiseasePicker = false">确认</span>
            </div>
            <div class="stry-bottom">
              <van-checkbox-group v-model="profileInfo.familyDisease">
                <van-cell v-for="item in Diseases" :key="item.ID" clickable>
                  <template #title>{{ item.DiseaseName }}</template>
                  <template #right-icon>
                    <van-checkbox
                      :name="item.ID"
                      :disabled="isPersonalDisease(item.ID)"
                    />
                  </template>
                </van-cell>
              </van-checkbox-group>
            </div>
          </van-popup>
        </div>
      </div>

      <button class="btn" @click="setProfile">保存</button>
    </div>

    <!-- 弹出层 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <van-picker
        title="性别"
        show-toolbar
        @cancel="show = false"
        :columns="option1"
        value-key="label"
        :default-index="genderIndex"
        @confirm="
          (e) => {
            this.profileInfo.gender = e.value;
            this.show = false;
          }
        "
      />
    </van-popup>

    <!-- 出生日期 -->
    <van-popup v-model="birthdayPicker" round position="bottom">
      <van-datetime-picker
        v-model="birthday"
        type="date"
        title="出生日期"
        @confirm="birthdayConfirm"
        :min-date="minDate"
        :max-date="maxDate"
    /></van-popup>

    <!-- 省份 -->
    <van-popup v-model="provincePicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="province"
        @cancel="provincePicker = false"
        @confirm="changeProvinceId2"
        value-key="name"
        :default-index="provinceIndex"
      />
    </van-popup>
    <van-popup v-model="districtsPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="districts"
        @cancel="districtsPicker = false"
        @confirm="changeDistricts2"
        value-key="name"
        :default-index="districtsIndex"
      />
    </van-popup>

    <!-- 城市 -->
    <van-popup v-model="citiesPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="cities"
        @cancel="citiesPicker = false"
        @confirm="changeCityId2"
        value-key="name"
        :default-index="citiesIndex"
      />
    </van-popup>

    <el-dialog
      title="修改头像"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="90%"
    >
      <ModifyAvatar @getUerInfo="getUerInfo"></ModifyAvatar>
    </el-dialog>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import {
  getAccount,
  getProfile,
  getProvinces,
  getCities,
  getDistricts,
  setProfile,
  getMaritalStatus,
  getEducations,
  getWorkingStatus,
  getIncomes,
  getPositions,
  getVehicleBrands,
  getVehicleBrandsModels,
  getDiseases,
  getWeChatAuthWechatUrl,
} from "@/api/mobile";

import ModifyAvatar from "@/components/modifyAvatar";
import { generateYearList, generateUUID } from "@/utils/replace";

export default {
  filters: {
    leablDateFrom(id, data) {
      const item = data.find((item) => {
        return item.value === id;
      });
      return item ? item.label : "";
    },
    nameFrom(id, data) {
      let name = "";
      if (data) {
        const item = data.find((item) => {
          return item.id === id;
        });
        name = item.name;
      }
      return name ? name : "";
    },
    labelName(id, data, name) {
      const item = data.find((item) => {
        return item.ID === id;
      });
      return item ? item[name] : "";
    },

    labelName2(list1, data) {
      let name = "";

      for (let i = 0; i <= list1.length - 1; i++) {
        const value = data.find((cItem) => {
          return cItem.ID == list1[i];
        });
        name = name + "," + value.DiseaseName;
      }

      // const value = data.find((cItem) => {
      //   return cItem.ID == item;
      // });
      // name = value.DiseaseName + ",";

      return name ? name.slice(1) : "";
    },
  },
  data() {
    return {
      show: false,
      dialogVisible: false,
      userInfo: {},
      profileInfo: {
        id: null,
        name: null,
        gender: null,
        birthday: null,
        provinceId: null,
        cityId: null,
        districtId: null,
        maritalStatus: null,
        educationId: null,
        occupationStatus: null,
        personalIncome: null,
        familyIncome: null,
        positionId: null,
        hasChildren: true,
        childGender: null,
        birthYearOfYoungChild: null,
        vehicleBrand: null,
        vehicleModel: null,
        vehiclePurchaseYear: null,
        personalDisease: [],
        familyDisease: [],
      },
      birthdayIndex: null,
      isName: false,
      birthday: null,
      option1: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      birthdayPicker: false,
      minDate: new Date("1990-01-01"),
      maxDate: new Date(),
      provincePicker: false,
      citiesPicker: false,
      districtsPicker: false,
      maritalStatusPicker: false,
      educationsPicker: false,
      OccupationStatusPicker: false,
      personalIncomePicker: false,
      familyIncomePicker: false,
      positionIdPicker: false,
      hasChildrenPicker: false,
      childGenderPicker: false,
      birthYearOfYoungChildPicker: false,
      vehicleBrandPicker: false,
      vehicleModelPicker: false,
      vehiclePurchaseYearPicker: false,
      personalDiseasePicker: false,
      familyDiseasePicker: false,

      province: null,
      cities: null,
      districts: null,

      MaritalStatus: [],
      Educations: [],
      OccupationStatus: [],
      Incomes: [],
      Incomes2: [],
      Positions: [],
      VehicleBrands: [],
      VehicleBrandsModels: [],
      Diseases: [],
      Diseases1: [],
      YearList: generateYearList(),
      options: [
        { ID: true, label: "是" },
        { ID: false, label: "否" },
      ],
      options1: [
        { ID: 1, label: "男" },
        { ID: 2, label: "女" },
      ],

      weixinFlag: false,
    };
  },
  components: { GoBack, ModifyAvatar },
  computed: {
    genderIndex() {
      let index = 0;
      if (this.profileInfo.gender) {
        index = this.profileInfo.gender - 1;
      }
      return index;
    },
    provinceIndex() {
      let index = 0;
      if (this.profileInfo.provinceId && this.province) {
        let newIndex = this.province.findIndex((item) => {
          return item.id === this.profileInfo.provinceId;
        });
        index = newIndex;
        console.log("省份", index);
      }
      return index;
    },
    citiesIndex() {
      let index = 0;
      if (this.profileInfo.cityId && this.cities) {
        let newIndex = this.cities.findIndex((item) => {
          return item.id === this.profileInfo.cityId;
        });
        index = newIndex;
      }
      return index;
    },
    districtsIndex() {
      let index = 0;
      if (this.profileInfo.districtId && this.districts) {
        let newIndex = this.districts.findIndex((item) => {
          return item.id === this.profileInfo.districtId;
        });
        index = newIndex;
      }
      return index;
    },
    MaritalIndex() {
      let index = 0;
      if (this.profileInfo.maritalStatus && this.MaritalStatus) {
        let newIndex = this.MaritalStatus.findIndex((item) => {
          return item.ID === this.profileInfo.maritalStatus;
        });
        index = newIndex;
      }
      return index;
    },

    EducationIndex() {
      let index = 0;
      if (this.profileInfo.educationId && this.Educations) {
        let newIndex = this.Educations.findIndex((item) => {
          return item.ID === this.profileInfo.educationId;
        });
        index = newIndex;
      }
      return index;
    },

    occupationStatusIndex() {
      let index = 0;
      if (this.profileInfo.occupationStatus && this.OccupationStatus) {
        let newIndex = this.OccupationStatus.findIndex((item) => {
          return item.ID === this.profileInfo.occupationStatus;
        });
        index = newIndex;
      }
      return index;
    },

    personalIncomeIndex() {
      let index = 0;
      if (this.profileInfo.personalIncome && this.Incomes) {
        let newIndex = this.Incomes.findIndex((item) => {
          return item.ID === this.profileInfo.personalIncome;
        });
        index = newIndex;
      }
      return index;
    },

    familyIncomeIndex() {
      let index = 0;
      if (this.profileInfo.familyIncome && this.Incomes) {
        let newIndex = this.Incomes.findIndex((item) => {
          return item.ID === this.profileInfo.familyIncome;
        });
        index = newIndex;
      }
      return index;
    },
    provinceIdIndex() {
      let index = 0;
      if (this.profileInfo.positionId && this.Positions) {
        let newIndex = this.Positions.findIndex((item) => {
          return item.ID === this.profileInfo.positionId;
        });
        index = newIndex;
      }
      return index;
    },

    hasChildrenIndex() {
      let index = 0;
      if (this.profileInfo.hasChildren && this.options) {
        let newIndex = this.options.findIndex((item) => {
          return item.ID === this.profileInfo.hasChildren;
        });
        index = newIndex;
      }
      return index;
    },
    childGenderIndex() {
      let index = 0;
      if (this.profileInfo.childGender && this.options1) {
        let newIndex = this.options1.findIndex((item) => {
          return item.ID === this.profileInfo.childGender;
        });
        index = newIndex;
      }
      return index;
    },

    birthYearOfYoungChildIndex() {
      let index = 0;
      if (this.profileInfo.birthYearOfYoungChild && this.YearList) {
        let newIndex = this.YearList.findIndex((item) => {
          return item.id === this.profileInfo.birthYearOfYoungChild;
        });
        index = newIndex;
      }
      return index;
    },

    vehicleBrandIndex() {
      let index = 0;
      if (this.profileInfo.vehicleBrand && this.VehicleBrands) {
        let newIndex = this.VehicleBrands.findIndex((item) => {
          return item.ID === this.profileInfo.vehicleBrand;
        });
        index = newIndex;
      }
      return index;
    },

    vehicleModelIndex() {
      let index = 0;
      if (this.profileInfo.vehicleModel && this.VehicleBrandsModels) {
        let newIndex = this.VehicleBrandsModels.findIndex((item) => {
          return item.ID === this.profileInfo.vehicleModel;
        });
        index = newIndex;
      }
      return index;
    },

    vehiclePurchaseYearIndex() {
      let index = 0;
      if (this.profileInfo.vehiclePurchaseYear && this.YearList) {
        let newIndex = this.YearList.findIndex((item) => {
          return item.id === this.profileInfo.vehiclePurchaseYear;
        });
        index = newIndex;
      }
      return index;
    },
  },
  methods: {
    isPersonalDisease(ID) {
      let flag = false;
      if (this.profileInfo.personalDisease.length === 0) {
        flag = false;
      }

      if (this.profileInfo.personalDisease.length === 1) {
        if (this.profileInfo.personalDisease[0] == 34) {
          if (ID != 34) {
            flag = true;
          }
        } else {
          if (ID == 34) {
            flag = true;
          }
        }
      }

      if (this.profileInfo.personalDisease.length >= 2) {
        if (ID == 34) {
          flag = true;
        }
      }

      return flag;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async getUerInfo() {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;

          this.$store.commit("changeUserInfo", this.userInfo);

          localStorage.setItem("userInfo", JSON.stringify(res.data));
          this.handleClose();
        }
      });
    },

    //获取基础信息
    async getProfile() {
      await getProfile().then((res) => {
        if (res.code) {
          this.profileInfo = {
            id: res.data.id,
            name: res.data.name,
            gender: res.data.gender || null,
            birthday: res.data.birthday,
            provinceId: res.data.provinceId || null,
            cityId: res.data.cityId || null,
            districtId: res.data.districtId || null,

            maritalStatus: res.data.maritalStatus || null,
            educationId: res.data.educationId || null,
            occupationStatus: res.data.occupationStatus || null,
            personalIncome: res.data.personalIncome || null,
            familyIncome: res.data.familyIncome || null,
            positionId: res.data.positionId || null,
            hasChildren: res.data.hasChildren,
            childGender: res.data.childGender || null,
            birthYearOfYoungChild: res.data.birthYearOfYoungChild
              ? res.data.birthYearOfYoungChild + ""
              : "",
            vehicleBrand: res.data.vehicleBrand || null,
            vehicleModel: res.data.vehicleModel || null,
            vehiclePurchaseYear: res.data.vehiclePurchaseYear
              ? res.data.vehiclePurchaseYear + ""
              : "",
            personalDisease: res.data.personalDisease || [],
            familyDisease: res.data.familyDisease || [],
          };

          if (!res.data.birthday) {
            this.birthdayIndex = new Date(this.profileInfo.birthday);
            this.birthday = new Date(this.profileInfo.birthday);
          } else {
            this.birthdayIndex = new Date();
            this.birthday = new Date();
          }

          if (res.data.name) {
            this.isName = true;
          }
        }
      });
    },
    formatDate(date) {
      let d = new Date(date);
      let year = d.getFullYear();
      let month = ("0" + (d.getMonth() + 1)).slice(-2); // 月份是从0开始的
      let day = ("0" + d.getDate()).slice(-2);
      return year + "-" + month + "-" + day;
    },
    //日历选择
    birthdayConfirm(date) {
      this.profileInfo.birthday = this.formatDate(date);
      this.birthdayPicker = false;
      console.log("this.profileInfo.birthday", this.profileInfo.birthday);
    },
    //获取省份
    async getProvinces() {
      await getProvinces().then((res) => {
        if (res.code === 200) {
          this.province = res.data;
        }
      });
    },
    changeProvinceId2(e) {
      this.profileInfo.provinceId = e.id;
      this.profileInfo.cityId = null;
      this.profileInfo.districtId = null;
      this.getCities();
      this.provincePicker = false;
    },
    //获取城市
    async getCities() {
      await getCities({
        id: this.profileInfo.provinceId,
      }).then((res) => {
        if (res.code === 200) {
          this.cities = res.data;
        }
      });
    },
    changeCityId2(e) {
      this.profileInfo.cityId = e.id;
      this.profileInfo.districtId = null;
      this.getDistricts();
      this.citiesPicker = false;
    },
    //获取区县
    async getDistricts() {
      await getDistricts({
        id: this.profileInfo.cityId,
      }).then((res) => {
        if (res.code === 200) {
          this.districts = res.data;
        }
      });
    },
    changeDistricts2(e) {
      this.profileInfo.districtId = e.id;
      this.districtsPicker = false;
    },

    //修改个人信息
    setProfile() {
      setProfile(this.profileInfo).then((res) => {
        console.log(res.code == 200);
        if (res.code == 200) {
          this.$toast("保存成功");
        }
      });
    }, //婚姻状况
    async getMaritalStatus() {
      await getMaritalStatus().then(async (res) => {
        if (res.code === 200) {
          this.MaritalStatus = res.data;
        }
      });
    },
    //学历
    async getEducations() {
      await getEducations().then(async (res) => {
        if (res.code === 200) {
          this.Educations = res.data;
        }
      });
    },

    //工作状态
    async getWorkingStatus() {
      await getWorkingStatus().then(async (res) => {
        if (res.code === 200) {
          this.OccupationStatus = res.data;
        }
      });
    },

    //收入
    async getIncomes() {
      await getIncomes().then(async (res) => {
        if (res.code === 200) {
          this.Incomes = res.data.map((item) => ({
            ...item,
            disabled: false,
          }));
          this.Incomes2 = JSON.parse(JSON.stringify(this.Incomes));
        }
      });
    },
    personalConfirm(e) {
      if (
        this.profileInfo.familyIncome &&
        e.ID > this.profileInfo.familyIncome
      ) {
        this.$toast("家庭年收入不能低于个人年收入");
      } else {
        this.profileInfo.personalIncome = e.ID;
        this.personalIncomePicker = false;
      }
    },
    familyConfirm(e) {
      if (
        this.profileInfo.personalIncome &&
        e.ID < this.profileInfo.personalIncome
      ) {
        this.$toast("家庭年收入不能低于个人年收入");
      } else {
        this.profileInfo.familyIncome = e.ID;
        this.familyIncomePicker = false;
      }
    },

    //职位
    async getPositions() {
      await getPositions().then(async (res) => {
        if (res.code === 200) {
          this.Positions = res.data;
        }
      });
    },
    //汽车品牌
    async getVehicleBrands() {
      await getVehicleBrands().then(async (res) => {
        if (res.code === 200) {
          this.VehicleBrands = res.data;
        }
      });
    },

    //汽车型号
    async getVehicleBrandsModels() {
      this.profileInfo.vehicleModel = null;
      this.profileInfo.vehiclePurchaseYear = null;
      if (this.profileInfo.vehicleBrand) {
        await getVehicleBrandsModels({
          id: this.profileInfo.vehicleBrand,
        }).then(async (res) => {
          if (res.code === 200) {
            this.VehicleBrandsModels = res.data || [];
          }
        });
      } else {
        this.VehicleBrandsModels = [];
      }
    },

    //患病
    async getDiseases() {
      await getDiseases().then(async (res) => {
        if (res.code === 200) {
          this.Diseases = res.data;
          this.changeGender();
        }
      });
    },

    changeGender() {
      console.log("改变性别", this.profileInfo.gender);
      this.Diseases1 = JSON.parse(JSON.stringify(this.Diseases));
      if (this.profileInfo.gender === 1) {
        const index1 = this.Diseases1.findIndex((item) => {
          return item.ID === 28;
        });
        console.log("index1", index1);
        this.Diseases1.splice(index1, 1);
      }

      if (this.profileInfo.gender === 2) {
        const index2 = this.Diseases1.findIndex((item) => {
          return item.ID === 18;
        });
        this.Diseases1.splice(index2, 1);
        const index3 = this.Diseases1.findIndex((item) => {
          return item.ID === 21;
        });
        this.Diseases1.splice(index3, 1);
      }
    },

    changePersonalDisease() {
      const data = this.profileInfo.personalDisease;
      if (data.length === 2 && data[0] === 34) {
        this.profileInfo.personalDisease.shift();
      } else if (data[data.length - 1] === 34) {
        this.profileInfo.personalDisease = [34];
      }
    },

    changeFamilyDisease() {
      const data = this.profileInfo.familyDisease;
      if (data.length === 2 && data[0] === 34) {
        this.profileInfo.familyDisease.shift();
      } else if (data[data.length - 1] === 34) {
        this.profileInfo.familyDisease = [34];
      }
    },
  },
  async created() {
    //微信自动登录
    if (this.$route.query.from && this.$route.query.from === "wechat") {
      this.weixinFlag = true;
      let state = generateUUID();
      let redirectUrl =
        "https://www.aidajuan.com/mobile/landingPage?url=" +
        "/mobile/personalData";
      await getWeChatAuthWechatUrl({
        redirectUrl,
        state,
      }).then((res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      });
      return;
    }
    if (this.weixinFlag) {
      return;
    }
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }
    await this.getProfile();
    await this.getProvinces();
    await this.getCities();
    await this.getDistricts();

    await this.getMaritalStatus();
    await this.getEducations();
    await this.getWorkingStatus();
    await this.getIncomes();
    await this.getPositions();
    await this.getVehicleBrands();
    await this.getDiseases();
    if (this.profileInfo.vehicleBrand) {
      await getVehicleBrandsModels({
        id: this.profileInfo.vehicleBrand,
      }).then(async (res) => {
        if (res.code === 200) {
          this.VehicleBrandsModels = res.data || [];
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8fa;
  .shadow {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 0;
  }
  .content-personal {
    position: relative;
    z-index: 1;
    padding: 0 15px 15px 15px;
    .gantan-box {
      display: flex;
      color: #232323;
      font-size: 12px;
      align-items: center;
      height: 30px;
      .gantan {
        width: 14px;
        height: 14px;
        margin-right: 10px;
      }
      span {
        color: #ff6017;
      }
    }
    // 头像部分
    .card-box {
      width: 100%;
      padding: 0 10px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 12px;
      box-sizing: border-box;
    }
    .head-card {
      font-size: 16px;
      color: #232323;
      padding-top: 13px;
      padding-bottom: 12px;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 56px;
          height: 56px;
          border-radius: 28px;
        }
        .head-box {
          position: relative;
          width: 68px;
          height: 68px;
          border-radius: 34px;
          .head {
            width: 68px;
            height: 68px;
            border-radius: 34px;
            cursor: pointer;
          }
          .picture-box {
            position: absolute;
            width: 68px;
            height: 68px;
            border-radius: 34px;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.4);
            color: #ddd;
            font-size: 20px;
          }
        }
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 25px;
        font-size: 14px;
      }
    }
    .user-info {
      font-size: 14px;
      color: #232323;
      .input-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 45px;
        border-bottom: 1px solid #f4f4f4;
        box-sizing: border-box;
        input {
          border: none;
          outline: none;
          text-align: right;
        }
        input::placeholder {
          color: #909090; /* 灰色的placeholder文本 */
          opacity: 1;
        }
        .choice-box {
          display: flex;
          align-items: center;
          color: #999999;
          font-size: 14px;
          img {
            width: 14px;
            height: 14px;
            margin-left: 8px;
          }

          .title2te {
            /* 1. 必须指定宽度（固定值或百分比） */
            width: 150px;
            /* 2. 强制文本不换行 */
            white-space: nowrap;
            /* 3. 隐藏超出容器的内容 */
            overflow: hidden;
            /* 4. 溢出时显示省略号 */
            text-overflow: ellipsis;
            text-align: right;
          }
        }
      }
    }
    .btn {
      width: calc(100% - 76px);
      height: 42px;
      background: linear-gradient(138deg, #bb95ff 0%, #8846ff 100%);
      border-radius: 25px 25px 25px 25px;
      padding: 0;
      margin: 0;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      font-size: 18px;
      color: #fff;
      border: none;
    }
  }
}
// .van-popup {
// max-width: 375px;
// position: fixed;
// left: 50%;
// transform: translatex(-50%);
// }
</style><style scoped>
.stry-top {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  align-items: center;
  height: 40px;
}
.stry-bottom {
  height: calc(100% - 40px);
  overflow-y: auto;
}
.stry-quxiao {
  color: #969799;
}
</style>